export default __webpack_public_path__ + "static/long-ac115b9c07250c1d1601c7c9f88ca768.png";